// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1fdb0f94","175":"490d8753"}[chunkId] + ".chunk.js";
};